import NormalApplause from '../assets/sounds/Applause.mp3';
import FailedApplause from '../assets/sounds/musicfx_btn_blingbl_01.mp3';
import EarnNonCurrencyReward from '../assets/sounds/musicfx_btn_boxappear_01.mp3';
import EarnCurrency from '../assets/sounds/musicfx_btn_earn_coin.mp3';
import BombExplosion from '../assets/sounds/musicfx_btn_explode_01_v2.mp3';
import FlipCard from '../assets/sounds/musicfx_btn_flip_01_Short.mp3';
import FullMarkApplause from '../assets/sounds/musicfx_btn_fulmark_01.mp3';
import WrongSelection from '../assets/sounds/musicfx_btn_hidewrong_01.mp3';
import CorrectSelection from '../assets/sounds/musicfx_btn_lightup_02.mp3';
import BombAlmostExplode from '../assets/sounds/musicfx_btn_outoftime_01.mp3';
import PayCurrency from '../assets/sounds/musicfx_btn_payment_01.mp3';

export const Sounds = {
  EarnCurrency,
  PayCurrency,
  EarnNonCurrencyReward,
  FullMarkApplause,
  FailedApplause,
  NormalApplause,
  BombExplosion,
  FlipCard,
  WrongSelection,
  CorrectSelection,
  BombAlmostExplode,
};
